var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":_vm.size},on:{"click":_vm.handleViewAuditDetail}},[_vm._v("审核记录")])}
var staticRenderFns = []

export { render, staticRenderFns }